import { render, staticRenderFns } from "./rema-gallery.vue?vue&type=template&id=63999272&scoped=true"
import script from "./rema-gallery.vue?vue&type=script&lang=js"
export * from "./rema-gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63999272",
  null
  
)

export default component.exports